module.exports = __webpack_public_path__ + "static/img/av-logo-auth.7b0b4a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/astrology/av-logo-auth.png
// module id = bUOx
// module chunks = 0